import React from 'react';
import './PersonalLoan.css';
import 'animate.css/animate.min.css';
import Seo from "../components/Seo";





function PersonalLoan() {
  return (
    <>

      <Seo
        title="Personal Loan – Quick Approval & Low Interest Rates | Mortbuzz"
        description="Get a personal loan with Mortbuzz at attractive interest rates. Enjoy instant approval, minimal documentation, and flexible repayment options for your needs."
        keywords="personal loan, instant personal loan, low interest personal loan, personal loan EMI, quick loan approval"
        canonical="https://www.mortbuzz.in/personal-loan"
      />








    {/* Meta tags (use react-helmet if needed) */}
      {/* Hero Section */}
      <section className="mortbuzzhheroPerson position-relative d-flex flex-column justify-content-center">
        <div className="overlay position-absolute top-0 start-0 w-100 h-100"></div>
        <div className="container">
          <h1 className="animate__animated animate__fadeInDown">Instant Cash for Life’s Big Moments Easy Payday loan in pune – MortBuzz Personal Loan in pune</h1>
          <p className="lead animate__animated animate__fadeInUp animate__delay-1s">Find the best personal loan provider in pune mortbuzz solutions tailored for you.</p>
          <a href="apply-now" className="apply-btn-glass mt-4 animate__animated animate__fadeInUp animate__delay-2s">Apply Now</a>
        </div>
      </section>



   {/* <!-- About Home Loan -->*/}
<section className="section bg-dark">
    <div className="container">
        <div className="row align-items-center">
            <div className="col-lg-6 mb-4">
                <img src="/images/FrontPage/personal-loan-fina-pc-view.png" className="img-fluid rounded shadow animate__animated animate__fadeInLeft" alt="personal loan mortbuzz"/>
            </div>
            <div className="col-lg-6 text-white">
                <h2 className="mb-4 text-white ">Why Choose MortBuzz for You Personal Loan in pune?</h2>
                <p>A personal loan is an unsecured credit that helps you take care of any kind of expense, ranging from wedding expenditures to medical bills. Personal loans can fill multiple financial gaps for you. Since they are secured in nature, you don’t have to pledge collateral or security to get the loan. Besides, there is no need to specify the end use. That is why, from funding your higher education, and home renovation, to foreign vacations and any type of unexpected expense, a best loan for personal use is the ideal option. personal loan in hadapsar pune for this people we provide upto 100% Cashback On All Bank Charges So Hurry Up & Apply Now Your Payday Loan In Pune.
</p>
                <ul className="list-unstyled mt-3">
                    <li>✅ Lowest Interest Rates 10.49%*</li>
                    <li>✅ High Loan Amounts</li>
                    <li>✅ 360-Degree Assistance</li>
                    <li>✅ Fast Loan Processing</li>
                    <li>✅ Upto 100% Cashback on Charges</li>
                    <li>✅ Doorstep Service</li>
                    <li>✅ Fast Loan Processing</li>
                </ul>
            </div>
        </div>
    </div>
</section>



{/*<!-- Loan Uses -->*/}
<section className="section bg-light">
    <div className="container text-center">
        <h2 className="mb-5">Uses of a Home Loan - Apply For personal Loan online</h2>
        <div className="row g-4">
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn">
                    <h5>Wedding</h5>
                    <p>Fund your dream wedding with a quick personal loan. Take care of all your expenses, from pre-wedding events to D-day ceremonies with ease. Whether you are throwing a big fat wedding or a small ceremony, a personal loan will help you fund all your expenses in one go. Compare best loan offers from different lenders to choose the right loan for your wedding.</p>
                </div>
            </div>
             <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn">
                    <h5>Home renovation</h5>
                    <p>House Renovation or upgrading your old house can give it an incredible face lift. Be it extending you balcony area or remodeling your kitchen, expenses can easily pile up. Fret not! A personal loan helps you tackle these costs without leaving a dent in your savings. Redesign your home or upgrade it with a personal loan for home renovation.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn">
                    <h5>Travel</h5>
                    <p>No more waiting till you’ve saved enough for your vacation. With a personal loan for travel, you can finance your holiday in the snowy alps of Switzerland or the white expanse of the Great Rann of Kutch. Fund all your travel expenses from airfare to hotel bookings without breaking the bank.</p>
                </div>
            </div>
             <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn">
                    <h5>Medical emergency</h5>
                    <p>Medical emergencies can be daunting. But, with a personal loan, you can take care of your emergency medical expenses with ease. With a quick personal loan, you don’t have to worry about long processing and disbursal times. Finance all your medical expenses with ease with the right loan.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-1s">
                    <h5>Education</h5>
                    <p>Education costs have skyrocketed with time. Whether you are working towards a rewarding career or upskilling while working, the right education is expensive. Comfortably finance your higher education needs or your loved ones’ with a personal loan. Take care of tuition costs and living expenses of studying abroad using a personal loan for education.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-2s">
                    <h5>Home loan down payment</h5>
                    <p>Eyes set on a property but struggling to make a down payment? Use a personal loan to make a sizeable down payment with ease. Since a home loan covers 75-85% of your property’s cost, use a personal loan to cover 100% of your expenses for salaried person personal loan & self-employed personal loan. When looking for the best bank for personal loan in India, let us help you make the right choice.
</p>
                </div>
            </div>
        </div>
    </div>
</section>



{/*<!-- Eligibility Criteria -->*/}
<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Personal Loan in Pune Eligibility Criteria</h2>
        <div className="row text-center">
            {/* CARD 1 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/salaried-image-icon.png" 
                        alt="Eligibility" 
                        style={{ width: '200px', height: '200px' }}
                        className="mb-3"
                    />
                    <p className="text-center">Salaried/Working Professional</p>
                </div>
            </div>
            {/* CARD 2 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/age.png" 
                        alt="Age" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3" 
                    />
                    <p className="text-center">Age: 21-60 Years</p>
                </div>
            </div>
            {/* CARD 3 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/3-month-experienced.png" 
                        alt="Experience" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Having a job and a minimum of<br />3 months experience</p>
                </div>
            </div>
            {/* CARD 4 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/minimum-income_20000.png" 
                        alt="Income" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Having a minimum of Rs. 25,000<br />net income per month.</p>
                </div>
            </div>
        </div>
    </div>
</section>




   {/* <!-- Apply Section -->*/}
<section id="apply" className="section bg-light text-center">
    <div className="container">
        <h2 className="mb-4">Ready to Start Your Journey? - personal Loan In Pune</h2>
        <p>Apply now and let MortBuzz Solutions Advisory guide you to the best Personal loan provider in pune options.</p>
        <a href="apply-now" className="apply-btn-glass btn-lg mt-3">Apply for Home Loan</a>
    </div>
</section>


{/*<!-- Documentation Required Section -->*/}
<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Documentation Required</h2>
        <div className="row g-5">

            {/*<!-- Photo Identity Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        
                        <img src="/images/Bank Pages/photo-identy.png" alt="Photo-ID" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Photo Identity Proof</h5>
                    </div>
                    <ul className= "text-white">
                        <li>Voter ID</li>
                        <li>Aadhaar Card</li>
                        <li>Passport</li>
                        <li>PAN Card</li>
                        <li>Driving Licence</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Proof of Residence -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/proof-of-residence.png" alt="Address Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Proof of Residence</h5>
                    </div>
                    <ul className="text-white">
                        <li>Aadhaar Card</li>
                        <li>Driving Licence</li>
                        <li>Passport</li>
                        <li>Registered Rent Agreement</li>
                        <li>Latest Gas/Electricity Bill</li>
                        <li>Bank Statement with Current Address</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Income Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/income-proof.png" alt="Income Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Income Proof</h5>
                    </div>
                    <ul className="text-white">
                        <li>Income Tax Returns (Last 3 Years)</li>
                        <li>Business License Details</li>
                        <li>Audited Balance Sheet & Profit/Loss (Last 3 Years)</li>
                        <li>Business Address Proof</li>
                        <li>6-Month Bank Statements (Current & Savings)</li>
                        <li>Copy of Form 16</li>
                        <li>6-Month Salary Account Statements</li>
                        <li>Last 3 Months’ Salary Slips</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Other Documents -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/other-document.png" alt="Other Documents" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Other Documents</h5>
                    </div>
                    <ul className="text-white" >
                        <li>Allotment Letter</li>
                        <li>Sale Deed</li>
                        <li>No Objection Certificate (NOC)</li>
                        <li>Allotment Letter from Society/Housing Board/Builder</li>
                        <li>Stamped Agreement of Sale</li>
                        <li>Possession Certificate</li>
                        <li>Construction Cost Estimate</li>
                        <li>Bank Payment Statement</li>
                        <li>Occupancy Certificate</li>
                        <li>Land Tax Receipt</li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</section>

{/*<!-- Application Process Section -->*/}
<section className="section bg-dark text-white py-5">
    <div className="container">
      <h2 className="text-center mb-5 text-white">Application Process</h2>
  
      <div className="timeline">
        {/*<!-- Step 1 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 1: Connect with Us</h4>
            <p>Explain your needs. We curate loan products most suitable for your profile.</p>
          </div>
        </div>
  
        {/*<!-- Step 2 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 2: Compare Loan Products</h4>
            <p>We help you compare several Personal loan products so you can choose the best one.</p>
          </div>
        </div>
  
        {/*<!-- Step 3 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 3: Apply Online</h4>
            <p>apply for Personal loan online,we will contact with you for your assistance.</p>
          </div>
        </div>
  
      {/*  <!-- Step 4 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 4: Application Processing</h4>
            <p>we verifies your documentation and processes the application.</p>
          </div>
        </div>
  
        {/*<!-- Step 5 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 5: Receive Funds</h4>
            <p>Upon approval, the loan amount is credited directly to your account.</p>
          </div>
        </div>
  
      </div>
    </div>
  </section>



  {/*<!-- Home Loan Rates Section -->*/}
<section className="section bg-light py-5">
    <div className="container">
      <h2 className="text-center mb-5">personal Loan in pune with Lowest Interest Rates</h2>
  
      <div className="table-responsive">
        <table className="table table-hover table-striped shadow-lg rounded">
          <thead className="table-primary">
            <tr>
              <th>Bank Name</th>
              <th>Min. Rate of Interest (%)</th>
              <th>Loan Amount</th>
              <th>Loan Tenure</th>
              <th>Processing Fees</th>
              <th>Apply Now</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><a href="https://applyonline.hdfcbank.com/personal-loans.html">HDFC Bank</a></td>
              <td>10.90%</td>
              <td>Upto 50 LAKH</td>
              <td>12 to 60 months</td>
              <td>3%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.idfcfirstbank.com/personal-banking/loans/personal-loan">ICFC Bank</a></td>
              <td>9.99%</td>
              <td>Upto 50 LAKH</td>
              <td>ranging from 12 months to 72 months</td>
              <td>3.5%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            
            <tr>
              <td><a href="https://www.bajajfinserv.in/personal-loan">Bajaj Finanace </a></td>
              <td>10%</td>
              <td>Upto 50 LAKH</td>
              <td>up to 96 months</td>
              <td>3.93%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.indusind.com/in/en/personal/loans/home-loan.html">IndusInd Bank</a></td>
              <td> 10.49%</td>
              <td> ₹30,000 up to ₹5 lakh</td>
              <td>period between 12 to 48 months</td>
              <td>3.5%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.axisbank.com/retail/loans/personal-loan">Axis Bank</a></td>
              <td>11.25%</td>
              <td>Rs. 50,000 - 40LAC</td>
              <td>12 months to 84 months</td>
              <td>1.5% to 2%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  </section>




  <section className="section py-5 bg-dark ">
    <div className="container">
      <div className="row align-items-center g-5">
        {/*<!-- Image Section -->*/}
        <div className="col-md-6 text-center">
          <img src="/images/FrontPage/mortbuzz-home-Loan-10.jpeg" alt="Processing Fee" className="img-fluid rounded shadow"/>
        </div>
  
        {/*<!-- Content Section -->*/}
        <div className="col-md-6">
          <h2 className="mb-4 text-primary" style={{fontWeight: '700'}}>Processing Fee</h2>
          <p style={{fontSize: '17px', color: '#FFEDFA'}}>
            Besides the <b>Personal loan in pune </b>interest rate, Processing fee is one of the key charges you pay on a<b> personal loan.</b> It is a one-time fee levied by your lending bank or NBFC for processing your<strong> personal loan application. </strong>This charge goes towards the administrative costs that the lender has to bear for processing and sanctioning the loan. The amount gets deducted from your loan amount at the time of the disbursement of funds.

          </p>
          <p style={{fontSize: '17px', color: '#FBFBFB'}}>
           Typically, the processing fee ranges between <b>1% to 2% </b>of your total loan amount. Additionally, a <b>GST</b> is applicable on the fee.
          </p>
          <p style={{fontSize: '17px', color: '#FBFBFB'}}>
            At<b> MortBuzz Solutions </b>Advisory, we help you find lenders who offer the lowest <b>processing fees </b>on <strong>Personal loans </strong>— ensuring you save more from the start.
          </p>
          
          <a href="apply-now" className="apply-btn-glass mt-3">Get Best Offers</a>
        </div>
      </div>
    </div>
  </section>




  {/*<!-- mortbuzz Additionally adding Text Box Section -->*/}

<section className="section bg-dark">
    <div className="container">
        <div className="row align-items-center">
            
            <div className="col-lg-6">
                <h2 className="mb-4 text-primary">MortBuzz Solutions Personal Loan Balance Transfer</h2>
                <p className="text-white">A best personal payday loan balance transfer is when a borrower moves their outstanding loan balance from one lender to another. It typically occurs when the new lender offers a lower interest rate on the outstanding loan balance. The primary goal of a personal loan transfer is to reduce the overall debt burden. You do not need to provide any collateral throughout the loan transfer process. Foreclosure fees, processing fees, etc., are some of the charges you need to pay during the balance transfer process. If you’re in the early stages of your loan, refinancing is a good idea. That’s when the interest component of your EMI is the highest. Over time, the interest component reduces. Thus, it is advisable to go for a balance transfer in the early stages of your loan to reap the most out of this option. It is also possible to consolidate your credit card dues into a personal loan for clearing them. If you are not able to pay your credit card bills, you can transfer the balance to a personal loan. This allows you to take advantage of the lower interest rates and longer repayment tenure that personal loans offer. Transferring your credit dues to a loan can also have a positive impact on your credit score as you shift from an expensive line of credit to a cheaper one. Your credit card provider may not always be willing to transfer your debt. So, you could apply for a personal loan with a new lender.

</p>
                <ul className="list-unstyled mt-3 text-white">
                    <li>✅ Lowest Interest Rates 10.49%*</li>
                    <li>✅ Instant Funds for Any Need</li>
                    <li>✅ Quick Approval & Disbursal</li>
                    <li>✅ Fast Loan Processing</li>
                    <li>✅ Minimal Documentation</li>
                    <li>✅ Doorstep Service</li>
                    <li>✅ Flexible Tenure Option</li>
                </ul>
            </div>
            <div className="col-lg-6 mb-4">
                <img src="/images/FrontPage/a-professional-portrait-photograph-of-a-_duQebNZKQ82xyx3-MhEhMw_ZEIIy3r6QK2G0OLBe2vLqw.jpeg" className="img-fluid rounded shadow animate__animated animate__fadeInLeft" alt="Dream House"/>
            </div>
        </div>
    </div>
</section>




 {/*<!-- FAQ Section -->*/}
<div className="w-100 px-3 px-md-5 py-5 bg-black text-white w-100 bg-black">
  <h2 className="text-center mb-5 display-4 fw-bold text-primary">Frequently Asked Questions</h2>

  <div className="row justify-content-center">
    <div className="col-lg-10 col-md-12">
      <div className="accordion" id="faqAccordion">

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
              <i className="bi bi-question-circle me-3 text-primary fs-4"></i>
              What is MortBuzz Home Loans and how can I apply for a loan?
            </button>
          </h2>
          <div id="faq1" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              A personal loan is an unsecured loan offered to individuals based on their income, credit score, and repayment ability. It can be used for any personal expenses like travel, medical bills, home renovation, or debt consolidation.
            </div>
          </div>
        </div>

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
              <i className="bi bi-percent me-3 text-primary fs-4"></i>
              Who is eligible to apply for a personal loan?
            </button>
          </h2>
          <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              You are eligible if you:
             <ul>
             <li>Are a salaried or self-employed individual</li>
             <li>Are aged between 21–60 years</li>
             <li>Have a stable income</li>
            <li>Maintain a good credit history (ideally 700+ CIBIL score)</li>
              
             </ul>
            </div>
          </div>
        </div>

       {/* <!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
              What are the documents required for a personal loan?
            </button>
          </h2>
          <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Generally, the required documents include:
              <ul className="mt-2">
                <li>PAN Card & Aadhaar Card</li>
                <li>Salary slips (last 3–6 months) or income proof</li>
                <li>Bank statements</li>
                 <li>Passport-size photo</li>
                <li>Employment certificate or ITR (if self-employed)</li>
              </ul>
            </div>
          </div>
        </div>

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What is the minimum and maximum loan amount I can get?
            </button>
          </h2>
          <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              You can typically borrow between ₹50,000 to ₹40 lakhs, depending on your profile and repayment capacity.


            </div>
          </div>
        </div>

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq5">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              How long is the repayment period?
            </button>
          </h2>
          <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              Personal loan tenures usually range from 12 to 60 months (1 to 5 years).
            </div>
          </div>
        </div>


       {/* <!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq6">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              Do I need to provide any collateral or guarantor?
            </button>
          </h2>
          <div id="faq6" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              No, personal loans are unsecured. You don’t need to submit any collateral or guarantor.
            </div>
          </div>
        </div>


        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq7">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What is the interest rate for a personal loan?
            </button>
          </h2>
          <div id="faq7" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Interest rates typically start at 10.49% per annum, depending on your credit score, employer profile, and loan amount.
            </div>
          </div>
        </div>
 {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq8">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              How long does it take to get the loan approved and disbursed?
            </button>
          </h2>
          <div id="faq8" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              If all documents are in order, approval can happen within 24–48 hours, and disbursal often takes 1 to 3 working days.


            </div>
          </div>
        </div>
 {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq9">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
               Can I apply online for a personal loan?
            </button>
          </h2>
          <div id="faq9" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Yes, with MortBuzz, you can apply completely online — from filling the form to uploading documents and tracking approval status.
            </div>
          </div>
        </div>

 {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq10">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              Can I foreclose or prepay my loan?
            </button>
          </h2>
          <div id="faq10" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Yes, most lenders allow prepayment or foreclosure, but some may charge a 2% to 5% fee on the outstanding amount. Check the terms before 
               proceeding.
            </div>
          </div>
        </div>


{/* <!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq11">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What happens if I miss an EMI payment?
            </button>
          </h2>
          <div id="faq11" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Missing EMI payments can:
              <ol>
                <li>Incur late payment penalties</li>
                <li>Lower your credit score</li>
                <li>Lead to legal consequences if ignored for long</li>
                
              </ol>
            </div>
          </div>
        </div>

 {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What is the process for obtaining a home loan from MortBuzz?
            </button>
          </h2>
          <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              <ol>
                <li>Apply at <a href="https://mortbuzz.in" className="text-primary">mortbuzz.in</a>.</li>
                <li>Our team will collect your documents.</li>
                <li>We handle approval with banks.</li>
                <li>Door-to-door service with no bank visits.</li>
                <li>Enjoy cashback and fast approval.</li>
              </ol>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>












      </>
  );
}

export default PersonalLoan;